import React, { Component } from 'react';
import { Phone } from '@cimpress/react-components';

export default class PhoneDemo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      e123PhoneNumber: '+1 508 832 3551 ext. 123',
      isValid: true,
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(phonePayload) {
    const { number, isValid } = phonePayload || {};
    this.setState({
      e123PhoneNumber: number,
      isValid,
    });
  }

  render() {
    return (
      <div>
        <p>Phone number is {this.state.isValid ? 'valid' : 'not valid'}</p>
        <p>Country list</p>
        <Phone
          onChange={this.onChange}
          initialValue={this.state.e123PhoneNumber}
          triggerChangeOnMount
          countrySelectMenuStyle={{
            minWidth: '450px', // prevent text wrapping of select options
          }}
          // Optional
          countryGroups={{
            'Frequently Used': ['us', 'fr', 'GB'],
            All: '*',
          }}
        />
      </div>
    );
  }
}
